export default [
	{
		value: 'arms',
		label: 'Arm Movement',
		icon: ['fas', 'drafting-compass'],
		description: 'The ability to move or control your arms.',
	},
	{
		value: 'bladder',
		label: 'Bladder Function',
		icon: ['fas', 'fill-drip'],
		description:
			'The ability to know when your bladder is full, or the ability to control emptying (micturition) without the use of a catheter.',
	},
	{
		value: 'blood_pressure',
		label: 'Blood Pressure',
		icon: ['fas', 'heartbeat'],
		description:
			`Improving your body's ability to control your blood pressure, or related items such as Autonomic Dysreflexia`,
	},
	{
		value: 'bones',
		label: 'Bone Strength',
		icon: ['fas', 'bone-break'],
		description:
			'An increase in bone density or stopping things that cause bones to weaken such as osteoporosis.',
	},
	{
		value: 'bowels',
		label: 'Bowel Function',
		icon: ['fas', 'poop'],
		description:
			'The ability to know when you need to empty your bowels, or the ability to control emptying your bowels without additional equipment or medication.',
	},
	{
		value: 'breathing',
		label: 'Breathing Function',
		icon: ['fas', 'lungs'],
		description:
			'The ability to breath independently without the use of equipment, or be able to improve your breathing function from where it is now.',
	},
	{
		value: 'hands',
		label: 'Hand Movement',
		icon: ['fas', 'hands'],
		description: 'The ability to move or control your hands.',
	},
	{
		value: 'legs',
		label: 'Leg Movement',
		icon: ['fas', 'socks'],
		description: 'The ability to move or control your legs.',
	},
	{
		value: 'motor',
		label: 'Motor Function',
		icon: ['fas', 'cogs'],
		description: 'The ability to move part of your body independently.',
	},
	{
		value: 'mental_health',
		label: 'Mental Health',
		icon: ['far', 'head-side-brain'],
		description: 'Improving your psychological well-being.',
	},
	{
		value: 'neuroprotection',
		label: 'Neuroprotection',
		icon: ['fas', 'umbrella'],
		description:
			"Protecting the spinal cord after injury so that further damage doesn't occur.",
	},
	{
		value: 'pain',
		label: 'Pain Management',
		icon: ['fas', 'bong'],
		description: 'Reducing your pain or the ability to control it.',
	},
	{
		value: 'plasticity',
		label: 'Plasticity',
		icon: ['fal', 'route'],
		description:
			'Neuroplasticity is the brain’s ability to form new nerve connections and pathways following injury or cell death.',
	},
	{
		value: 'pressure',
		label: 'Pressure Sores',
		icon: ['fas', 'band-aid'],
		description:
			'Also known as decubitus ulcer. A potentially dangerous skin breakdown due to pressure on skin resulting in infection, tissue death.',
	},
	{
		value: 'quality_of_life',
		label: 'Quality of Life',
		icon: ['fas', 'star-of-life'],
		description:
			'An improvement in the interaction with your social or physical environments. Basically something that may improve your life.',
	},
	{
		value: 'regeneration',
		label: 'Regeneration',
		icon: ['fas', 'seedling'],
		description:
			'Regrowth and reconnection of damaged fibres, nerves and connections in the spinal cord.',
	},
	{
		value: 'sensation',
		label: 'Sensory Function',
		icon: ['fas', 'feather'],
		description:
			'The ability to feel something, either through touch or your mind knowing something has happened.',
	},
	{
		value: 'sex',
		label: 'Sexual Function',
		icon: ['fas', 'magic'],
		description:
			'Covers the ability to get an erection through to orgasm or ejaculation for men. For women includes the ability to orgasm.',
	},
	{
		value: 'spasticity',
		label: 'Spasticity',
		icon: ['fas', 'diagnoses'],
		description: 'Hyperactive muscles that move or jerk involuntarily.',
	},
	{
		value: 'temperature',
		label: 'Temperature Control',
		icon: ['fas', 'thermometer-empty'],
		description:
			'The ability for your body to regulate its own temperature, sweating etc.',
	},
	{
		value: 'trunk',
		label: 'Trunk Control',
		icon: ['fal', 'user'],
		description: 'An improvement in your trunk control and balance.',
	},
	{
		value: 'walking',
		label: 'Walking Function',
		icon: ['fas', 'walking'],
		description: 'The ability to walk, or an improvement in walking ability.',
	},
] as const;
